import Hls from 'hls.js';

/** Мягкий приоритет высокого битрейта (аналог VHS-опций для видео). */
export const HLS_HIGH_BITRATE_OPTIONS = {
  abrEwmaDefaultEstimate: 8_000_000,
  capLevelToPlayerSize: false,
};

export function isDirectAudioFile(url) {
  return /\.(mp3|mp4|aac|ogg|wav)(\?|$)/i.test(url || '');
}

export function isHlsAudioStream(url) {
  if (!url || isDirectAudioFile(url)) {
    return false;
  }

  return /\.m3u8(\?|$)/i.test(url) || /mpegurl/i.test(url);
}

export function attachHlsAudio(audioEl, url, existingHls) {
  if (existingHls) {
    existingHls.destroy();
  }

  if (!Hls.isSupported()) {
    audioEl.src = url;
    return null;
  }

  const hls = new Hls(HLS_HIGH_BITRATE_OPTIONS);
  hls.loadSource(url);
  hls.attachMedia(audioEl);

  return hls;
}

export function destroyHls(hls) {
  if (hls) {
    hls.destroy();
  }
}

/**
 * URL для mediastata watcher: mounts вида /live/.../icecast.audio,
 * плеер часто отдаёт HLS (.../playlist.m3u8).
 */
export function toMediastataMountUrl(streamUrl) {
  if (!streamUrl) {
    return streamUrl;
  }
  try {
    const u = new URL(streamUrl, typeof window !== 'undefined' ? window.location.origin : 'https://local');
    const match = u.pathname.match(/^(\/live\/[^/]+)\//);
    if (match) {
      u.pathname = `${match[1]}/icecast.audio`;
      u.search = '';
      u.hash = '';
      return u.toString();
    }
  } catch (_) {
    // ignore
  }
  return streamUrl;
}

/** Play → наш bridge (очередь, если ещё не ready) + их __onAudioStarted. */
export function notifyMediastataAudioStarted(streamUrl) {
  if (typeof window === 'undefined' || !streamUrl) {
    return;
  }
  const url = toMediastataMountUrl(streamUrl);

  try {
    if (typeof window.__onAudioStarted === 'function') {
      window.__onAudioStarted(url);
    }
  } catch (_) {
    // ignore
  }

  if (typeof window.__mediastataBridgeNotify === 'function') {
    Promise.resolve(window.__mediastataBridgeNotify(url)).catch(() => {});
    return;
  }

  // Stub ещё не повесили (poll не на этой странице / скрипт не загружен).
  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    if (typeof window.__mediastataBridgeNotify === 'function') {
      Promise.resolve(window.__mediastataBridgeNotify(url)).catch(() => {});
      window.clearInterval(timer);
      return;
    }
    if (attempts >= 40) {
      window.clearInterval(timer);
    }
  }, 250);
}
